import useArticleImportRequest from "../useArticleImportRequest";
import React, { useState } from 'react';
import apiUrl from '../../Apiurl';
import stilePulsanti from '../../interfaccia/stilePulsanti';

function CSVCategorie(props) {
  const uploadArticleCsv = useArticleImportRequest(props.utente);

  
    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [risultatoOperazione, setRisultatoOperazione] = useState("In attesa dell'upload");

    const {
      inputClassesConTasto,
      classiTastoSblocco,
      tastoCopiaAspetto,
      buttonClassesWhite
  } = stilePulsanti

/*     const query = `SELECT p.id_product, p.reference as "ID PROD",
    (SELECT fvl.value 
     FROM "ps_feature_product" fp 
     JOIN ps_feature_value fv ON (fp."id_feature_value" = fv."id_feature_value" AND fp."id_feature" = 453)
     JOIN "ps_feature_value_lang" fvl ON (fv."id_feature_value" = fvl."id_feature_value" AND fvl."id_lang" = 5)
     WHERE fp."id_product" = p.id_product
    ) as "Codice produttore",
    
    (SELECT m.name 
        FROM "ps_manufacturer" m
        WHERE m."id_manufacturer" = p.id_manufacturer
    ) AS "Brand",
    
    (SELECT pl.name FROM ps_product_lang pl WHERE id_lang = 5 AND pl.id_product = p.id_product) AS "name_IT"
    
    FROM ps_product p` */

    const changeHandler = (event) => {
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
    };

    const handleSubmission = () => {
      const formData = new FormData();

      formData.append('uploaded_file', selectedFile);

      uploadArticleCsv(apiUrl+"/csv/categorie", formData)
        .then((result) => {
          setRisultatoOperazione("Dati caricati correttamente")
          console.log('Success:', result);
        })
        .catch((error) => {
          setRisultatoOperazione(error.message);
          console.error('Error:', error);
        });
    };


  return (
    
    <div className='flex colonnaTuttaPagina'>
      <div className="w-30 fr pl4 pr4 ">
        <h1>Categorie Web</h1>
        <p>Integra solo i dati mancanti.</p>
        <input type="file" accept="csv" name="file" onChange={changeHandler} />
        {isFilePicked ? (
          <div>
            <p>Nome del file: {selectedFile.name}</p>
            <p>Tipo file: {selectedFile.type}</p>
            <p>Dimensione in bytes: {selectedFile.size}</p>
            <p>
              Data ultima modifica:{' '}
              {selectedFile.lastModifiedDate.toLocaleDateString()}
            </p>
          </div>
        ) : (
          <p>Seleziona un file</p>
        )}
        <div>
          <button onClick={handleSubmission} className="f6 link dim ba b--dark-green ph3 pv2 mt4 dib white bg-dark-green br3 mr2 w-70 center">Carica</button>
        </div>
        <p>{risultatoOperazione}</p>
      </div>
      {/* <div className="w-50 fr sezioneConScroll colonna90vh">
          <div className='pa4'>
          <span><button onClick={(e) => navigator.clipboard.writeText(query).then(e.preventDefault())} className={buttonClassesWhite}>{tastoCopiaAspetto}</button></span><span>Copia la query in clipboard</span>
          </div>
      <pre>
{query}
          </pre>
      </div> */}
    </div>
  )

}





export default CSVCategorie;